/** Only bounded read shortcuts belong here. Unrecognized requests keep the agent path. */
export const normalizeNovaRequest = (text: string) => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  .toLowerCase().replace(/[’‘]/g, "'")
  .replace(/\b(?:reprots|repots|reprts)\b/g, 'reports')
  .replace(/\b(?:sacns|scnas)\b/g, 'scans')
  .replace(/\bweb\s+(reports?|scans?|analys(?:is|es))\b/g, 'website $1')
  .replace(/\b(?:avliable|avaliable|availble)\b/g, 'available');

export const mentionsOtherReportType = (text: string) =>
  /\b(documents?|pdfs?|media|videos?|youtube|amazon|meta|facebook|instagram|images?|attachments?|arquivos?|documentos?|midia)\b/.test(text);

export function requestsWebsiteReportDiscussion(text: string, hasReport: boolean): boolean {
  if (!hasReport) return false;
  const s = normalizeNovaRequest(text);
  if (mentionsOtherReportType(s) || /\b(compare|compar\w*|delete|remove|create|start|cancel|don't|do not|dont|nao)\b/.test(s)) return false;
  const action = /\b(review|discuss|analy[sz]e|summari[sz]e|summ[ae]ry|overview|findings|take a look|look at|tell me about|analis\w*|resum\w*)\b/.test(s);
  const target = /\b(?:this|that|current|selected)\s+(?:website\s+)?(?:report|scan|analysis)\b/.test(s)
    || /\b(?:the\s+)?(?:report|scan|analysis)\s*[?.!]*$/.test(s)
    || /\b(it|this|that|esse|este|isso)\s*[?.!]*$/.test(s);
  return action && target && !/\b(what is|what are|define|meaning of|o que e)\b/.test(s.replace(/what are the findings/g, 'findings'))
    && !/https?:\/\/|\b(for|from)\s+(?!this\b|the selected\b|the current\b)/.test(s);
}
